import React, { useEffect, useState } from "react";
import DashboardWrapper from "../components/DashboardWrapper";
import DashboardCard from "../components/dashboard/DashboardCard";
import dashboardService from "../services/dashboardService";
import "../dashboard.css";
import Loader from "../components/Loader";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDashboardStats = async () => {
    try {
      const response = await dashboardService.getAdminDashboardDetails();
      if (response?.data?.success) {
        setStats(response.data.data);
      } else {
        setStats(null);
      }
    } catch (error) {
      console.error("Dashboard API Error:", error);
      setStats(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  // 🔄 Loading State
  if (loading) {
    return (
      <DashboardWrapper>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Loader />
        </div>
      </DashboardWrapper>
    );
  }

  // ❌ Error / No Data State
  if (!stats) {
    return (
      <DashboardWrapper>
        <div className="text-center mt-5">
          <h4>Failed to load dashboard data</h4>
        </div>
      </DashboardWrapper>
    );
  }

  // ✅ Dashboard UI
  return (
    <DashboardWrapper>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">

          <DashboardCard
            title="Total Sales Revenue"
            value={`₹${stats.total_sales_revenue ?? 0}`}
            gradient="gradient-1"
          />

          <DashboardCard
            title="Total Orders"
            value={stats.total_orders ?? 0}
            gradient="gradient-2"
          />

          <DashboardCard
            title="Total Complete Orders"
            value={stats.total_completed_orders ?? 0}
            gradient="gradient-3"
          />

          <DashboardCard
            title="Total Pending Orders"
            value={stats.total_pending_orders ?? 0}
            gradient="gradient-4"
          />

          <DashboardCard
            title="Total Cancelled Orders"
            value={stats.total_cancelled_orders ?? 0}
            gradient="gradient-5"
          />

          <DashboardCard
            title="Total Products"
            value={stats.total_products ?? 0}
            gradient="gradient-6"
          />

          <DashboardCard
            title="Total Active Products"
            value={stats.total_approved_products ?? 0}
            gradient="gradient-7"
          />

          <DashboardCard
            title="Total Inactive Products"
            value={stats.total_pending_approval_products ?? 0}
            gradient="gradient-8"
          />

            <DashboardCard
            title="Total Sold Products"
            value={stats.total_sold_products ?? 0}
            gradient="gradient-8"
          />

          <DashboardCard
            title="Total Categories"
            value={stats.total_categories ?? 0}
            gradient="gradient-9"
          />

          <DashboardCard
            title="Total Customers"
            value={stats.total_customers ?? 0}
            gradient="gradient-10"
          />

        </div>
      </div>
    </DashboardWrapper>
  );
};

export default AdminDashboard;
